/* ================================
   NearbyGuide – Central Image Store
   ================================ */

/* CATEGORY / PAGE IMAGES */
import cafe from "./cafe.png";
import cityPark from "./city_park.png";
import coachingInstitute from "./coaching_institue_classroom.png";
import hospital from "./hospital.png";
import medicalClinic from "./medical_clinic.png";
import pharmacy from "./pharmacy.png";
import realEstate from "./real_estate_apartment.png";
import restaurant from "./resturant_interior.png";
import school from "./school.png";
import shoppingMall from "./shopping_mall_interior.png";
import temple from "./temple.png";
import touristPlace from "./tourist_place.png";
import university from "./university.png";
import waterPark from "./water_park.png";

import airportImg from "./airport.png";
import busStandImg from "./busstand.png";
import hotelImg from "./hotel.png";
import religiousImg from "./religius.png";
import stadiumImg from "./stadium.png";
import railwayImg from "./train.png";

/* HERO / SECTIONS */
import heroBg from "./hero-bg-img.png";
import heroImage from "./hero-image.png";
import popularCitiesBgMobile from "./popular-cities-bg-mobile.png";
import popularCitiesBg from "./popular-cities-bg.png";

/* BRANDING */
import faviconB from "./faciconB.png";
import faviconBC from "./faviconBC.png";
import logoB from "./logoB.png";
import logoBC from "./logoBC.png";
import logoBT from "./logoBT.png";
import logoT from "./logoT.png";
import logoW from "./logoW.png";
import logoWT from "./logoWT.png";

/* ================================
   EXPORT MAPS
   ================================ */

export const CATEGORY_IMAGES = {
  cafe,
  citypark: cityPark,
  coaching: coachingInstitute,
  hospital,
  clinic: medicalClinic,
  medicalstore: pharmacy,
  realestate: realEstate,
  restaurant,
  school,
  mall: shoppingMall,
  mandir: temple,
  tourist: touristPlace,
  college: university,
  waterpark: waterPark,

  // 🔥 added
  hotel: hotelImg,
  stadium: stadiumImg,
  railway: railwayImg,
  busstand: busStandImg,
  airport: airportImg,
  religious: religiousImg,
};

export const HERO_IMAGES = {
  heroBg,
  heroImage,
};

export const SECTION_IMAGES = {
  popularCitiesBg,
  popularCitiesBgMobile,
};

export const BRAND_IMAGES = {
  faviconB,
  faviconBC,
  logoB,
  logoBC,
  logoBT,
  logoT,
  logoW,
  logoWT,
};
